"use client";
import {
	signInWithPopup,
	setPersistence,
	browserSessionPersistence,
} from "firebase/auth";
import getLogin from "@/firebase/firestore/getLogin";
import useUser from "@/hooks/useUser";
import { icons } from "@/components/icons";
import { useEffect, useState } from "react";
import getByIDs from "@/firebase/firestore/getByIDs";
import Favs from "./Favs";

import Logout from "./Logout";

export default function Login({ className }) {
	const { auth, provider } = getLogin();
	const { user, loading } = useUser();

	const [userHandle, setUserHandle] = useState(false);

	const [exp, setExp] = useState(false);

	useEffect(() => {
		if (user?.uid) {
			getByIDs("users", [user.uid]).then((r) => {
				if (r.length === 0) {
					// router.push("/signup");
				} else {
					setUserHandle(r[0]?.handle ? r[0].handle : user.email);
				}
			});
		}
	}, [user]);

	const login = () => {
		signInWithPopup(auth, provider).then(() => {
			setPersistence(auth, browserSessionPersistence);
		});
	};

	return loading ? (
		<div className=" animate-spin">{icons.loader}</div>
	) : user ? (
		<div className={className + " relative rounded-full p-1 pr-2"}>
			{exp && (
				<div
					className="absolute bottom-full left-2 -ml-px mb-4 flex w-[200px] flex-col rounded bg-white p-2 ring-1 ring-dark-900/5 dark:bg-dark-900"
					onClick={() => setExp(false)}
				>
					<div
						onClick={() => setExp(false)}
						className="wu hu flexer absolute bottom-full left-full cursor-pointer rounded-full bg-white text-dark-900 opacity-50 dark:bg-dark-900 dark:text-white"
					>
						{icons.close}
					</div>
					<Favs className="flex cursor-pointer items-center justify-between rounded p-2 hover:bg-dark-100 dark:hover:bg-dark-700">
						My Meshes
					</Favs>

					<Logout className="cursor-pointer p-2 hover:bg-red-400/5 hover:text-red-500" />
				</div>
			)}
			<div
				className="flex cursor-pointer items-center gap-2"
				onClick={() => setExp(!exp)}
			>
				<div
					style={{ backgroundImage: `url(${user.photoURL})` }}
					className="block h-6 w-6 rounded-full border bg-cover"
				></div>
				<span>{userHandle}</span>
				<div className="scale-50">
					{icons[exp ? "close" : "arrowDown"]}
				</div>
			</div>
		</div>
	) : (
		<div
			className={className + " flex cursor-pointer items-center "}
			onClick={login}
		>
			<div className="wu hu flexer">{icons.login}</div>
			<div className="miniLabel -ml-1 p-1 uppercase">Login</div>
		</div>
	);
}
